import React, { useEffect, useState } from 'react'
import { showErrorToast } from '../../../../utils/showToast'
import { CloseButton, ETitle, Modal } from '../../../../components/ui'
import { Button } from '../../../../components/ui/legacy'

import useGetErrorByUUID from '../hooks/useGetErrorByUUID'
import { Meta, SimpleTextArea } from '../../../../components/ui/legacy'
import { UTitle } from '../../../../components/ui'

import { convertTrackingListToTabs } from '../error_report_utils'
import useRefuseErrorReportByUUIDMutation from '../hooks/useRefuseErrorReportByUUIDMutation'
import ErrorResponseModal from './ErrorResponseModal'

function ErrorDetailLogs({ trackingList }) {
  const [activeTab, setActiveTab] = useState(0)
  const [tabs, setTabs] = useState([])

  useEffect(() => {
    if (trackingList) {
      setTabs(convertTrackingListToTabs(trackingList))
    }
  }, [trackingList])

  return (
    <div>
      <h2 className="mb-4 text-lg font-bold md:text-2xl">BẢN GHI HỆ THỐNG</h2>
      <div className="rounded-md bg-white shadow-md">
        <ul className="flex overflow-x-auto border-b border-gray-200">
          {tabs.map((tab, index) => (
            <li
              className={`mr-2 cursor-pointer rounded-tl-md rounded-tr-md px-6 py-3 text-sm font-medium transition-colors duration-200 ${
                activeTab === index
                  ? 'border-b-2 border-gray-accent bg-gray-200 text-gray-accent'
                  : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
              }`}
              key={tab.id}
              onClick={() => setActiveTab(index)}
            >
              <span className="select-none">{tab.label}</span>
            </li>
          ))}
        </ul>

        <div className="bg-white p-2">
          <div className="max-h-[25vh] min-h-[10vh] w-full overflow-auto rounded-md text-sm">
            {tabs[activeTab]?.content}
          </div>
        </div>
      </div>
    </div>
  )
}

function ErrorDetailOverview({ createdOn, createdBy, major, text }) {
  return (
    <div>
      <UTitle text={'THÔNG TIN CHUNG'} />
      <div>
        <Meta title={'Ngày báo lỗi'} content={createdOn} />
        <Meta title={'Người báo lỗi'} content={createdBy} />
        <Meta title={'Lớp chuyên ngành'} content={major} />
        <Meta title={'MÔ TẢ VẤN ĐỀ'} />
        <SimpleTextArea
          color="bg-blue-100"
          value={text}
          className="max-h-[25vh]"
          disabled
        />
      </div>
    </div>
  )
}

export default function ErrorDetailModal({ uuid, closeHandler }) {
  const { data, isLoading } = useGetErrorByUUID(uuid)
  const [openModal, setOpenModal] = useState(false)
  const { refuseErrorReportByUUIDMutation } =
    useRefuseErrorReportByUUIDMutation()
  const RejectReport = (event) => {
    event.preventDefault()
    refuseErrorReportByUUIDMutation.mutate(uuid)

    showErrorToast({ message: 'Chưa cập nhật' })
  }

  // // XỬ LÝ LẤY FILE VỀ
  const AnswerReport = (event) => {
    event.preventDefault()
    setOpenModal(true)
    // showErrorToast({ message: 'Chưa cập nhật' })
  }
  if (isLoading) {
    return
  }
  return (
    <Modal
      className={
        'grid w-[600px] grid-cols-1 gap-2 rounded-lg bg-white p-8 md:w-[800px] md:gap-5'
      }
      onClose={closeHandler}
    >
      <header className="flex items-start justify-between gap-1 md:gap-2">
        <ETitle text={`CHI TIẾT BÁO LỖI CỦA NGƯỜI DÙNG ${data.studentId}`} />
        <CloseButton onClickHandler={closeHandler} />
      </header>
      <section className="mt-4 grid grid-cols-1 gap-5 md:gap-9">
        <ErrorDetailOverview
          createdOn={data.reportedAt}
          createdBy={data.studentId}
          text={data.content}
          major={data.studentId}
        />

        <ErrorDetailLogs trackingList={data.trackingList} />
      </section>
      <div className="flex justify-center gap-8">
        <Button variant={'super'} onClickHandler={RejectReport}>
          Từ chối báo lỗi này
        </Button>
        <Button variant={'primary'} onClickHandler={AnswerReport}>
          Gửi email phản hồi
        </Button>
      </div>

      {openModal ? (
        <ErrorResponseModal
          closeErrorResponseModal={closeHandler}
          userID={data.studentId}
          responseCode={data.uuid}
          uuid={data.uuid}
        />
      ) : null}
    </Modal>
  )
}
